<template>
  <div class="map-content" v-if="routeMap">
    <div class="map-holder">
      <div id="map"></div>
    </div>
    <div class="points">
      <RoutePoints :waypoints="waypoints"></RoutePoints>
    </div>
  </div>
  <div v-else class="alert alert-danger text-center">No valid map found!</div>
</template>

<script>
import { Loader } from 'google-maps';
import credentials from '@/config/credentials.js';
import { vehicleRequest } from '../../../store/vehicleRequest/vehicleRequest';
import RoutePoints from '../vehicleRequest/RoutePoints.vue';

export default {
  props: ['mapData'],
  components: {
    RoutePoints
  },
  data() {
    return {
      google: '',
      map: '',
      coordinates: {
        lat: 23.810431079332343,
        lng: 90.41242187756868
      },
      zoom: 13,
      routeMap: null,
      waypoints: [],
      directionsService: '',
      directionsDisplay: '',
      infoWindow: '',
      vehicleRequest
    };
  },
  beforeMount() {
    this.loader = new Loader(credentials.GOOGLE_MAP_API_KEY, {
      libraries: ['places', 'marker']
    });
  },
  mounted() {
    this.setMap();
  },
  watch: {
    mapData() {
      this.setMap();
    }
  },
  methods: {
    setMap() {
      this.waypoints = [];
      this.routeMap = vehicleRequest.decodeMapData(this.mapData);

      if (this.routeMap) {
        this.waypoints = [...this.routeMap.pickData, ...this.routeMap.dropData];

        this.loader.load().then((google) => {
          this.google = google;
          if (document.getElementById('map')) {
            this.map = new google.maps.Map(document.getElementById('map'), {
              center: this.coordinates,
              zoom: this.zoom,
              mapTypeId: 'roadmap',
              gestureHandling: 'greedy'
            });
            this.directionsService = new google.maps.DirectionsService();
            this.directionsDisplay = new google.maps.DirectionsRenderer({
              map: this.map,
              // draggable: true,
              suppressMarkers: true,
              polylineOptions: {
                strokeWeight: 5,
                strokeColor: '#652f8f'
                //   strokeOpacity: 0.3
              },
              preserveViewport: true
            });
            this.infoWindow = new google.maps.InfoWindow({
              maxWidth: 200
            });
            this.directionsDisplay.setMap(this.map);

            this.showDirection();
            this.setMarkers();
          }
        });
      }
    },
    showDirection() {
      if (
        this.routeMap?.pickData?.length > 0 &&
        this.routeMap?.dropData?.length > 0 &&
        this.routeMap?.viaWaypoints
      ) {
        let pickData = this.routeMap.pickData;
        let dropData = this.routeMap.dropData;
        let origin = pickData[0];
        let destination = dropData[dropData.length - 1];

        this.directionsService
          .route({
            origin: origin.location,
            destination: destination.location,
            waypoints: this.routeMap.viaWaypoints,
            travelMode: this.google.maps.DirectionsTravelMode['DRIVING']
          })
          .then((result) => {
            this.directionsDisplay.setDirections(result);

            let bounds = new this.google.maps.LatLngBounds();
            bounds.union(result.routes[0].bounds);
            this.map.fitBounds(bounds);
          })
          .catch((e) => {
            alert('Could not display directions due to: ' + e);
          });
      }
    },
    setMarkers() {
      let map = this.map;
      if (
        this.routeMap?.pickData?.length > 0 &&
        this.routeMap?.dropData?.length > 0
      ) {
        let firstPickIcon = {
          url: 'https://img.icons8.com/?size=512&id=vk4Ai_C9IAa4&format=png',
          scaledSize: new this.google.maps.Size(35, 35)
        };
        let pickIcon = {
          url: 'https://img.icons8.com/?size=512&id=vk4Ai_C9IAa4&format=png',
          scaledSize: new this.google.maps.Size(30, 30)
        };
        let dropIcon = {
          url: 'https://img.icons8.com/?size=512&id=zXQ8doTO6GgM&format=png',
          scaledSize: new this.google.maps.Size(30, 30)
        };
        let lastDropIcon = {
          url: 'https://img.icons8.com/?size=512&id=zXQ8doTO6GgM&format=png',
          scaledSize: new this.google.maps.Size(35, 35)
        };
        this.routeMap.pickData.forEach((pick, index) => {
          new this.google.maps.Marker({
            position: pick.location,
            map,
            icon: index === 0 ? firstPickIcon : pickIcon
          });
        });
        this.routeMap.dropData.forEach((pick, index) => {
          new this.google.maps.Marker({
            position: pick.location,
            map,
            icon:
              index === this.routeMap.dropData.length - 1
                ? lastDropIcon
                : dropIcon
          });
        });
      }
    }
  }
};
</script>

<style scoped>
.map-holder {
  width: 100%;
  height: 340px;
  margin-bottom: 16px;
  border-radius: 6px;
  overflow: hidden;
}
#map {
  width: 100%;
  height: 100%;
}
</style>
